<template>
    <v-skeleton-loader v-if="tasks === false" class="mx-auto" height="421" type="ossein"></v-skeleton-loader>
    <div v-else>
        <p class="text-small font-weight-medium text-primary">
            <i class="icon icon-Tasksmallicon icon-lg me-2"><span class="icon path1"></span><span class="icon path2"></span></i>یادداشت‌های شخصی
        </p>
        <v-text-field
            class="my-3"
            :disabled="todoSpinner"
            @keydown.enter="createNewTask"
            hide-details
            bg-color="grey-lighten-3"
            label="قرار است روی چه چیزی کار کنید؟"
            variant="solo"
            v-model="newTask"
        >
            <template #append-inner>
                <v-icon @click="createNewTask" v-if="newTask && !todoSpinner">add_circle</v-icon>
                <v-progress-circular v-if="todoSpinner" color="primary" indeterminate size="20" width="2"></v-progress-circular>
            </template>
        </v-text-field>
        <p class="font-weight-medium text-small text-primary">
            <v-fade-transition leave-absolute>
                <span :key="`tasks-${tasks.length}`" class="me-1">{{ tasks.length }}</span>
            </v-fade-transition>مورد برنامه‌ریزی شده&nbsp;
        </p>
        <v-divider class="mt-4"></v-divider>
        <div class="d-flex ga-2 align-center py-1">
            <p class="text-small font-weight-medium text-error">انجام نشده: {{ remainingTasks }}</p>
            <v-divider vertical></v-divider>
            <p class="text-small font-weight-medium text-success">انجام شده: {{ completedTasks }}</p>
            <v-btn color="error" icon="icon-trash" variant="text" v-tooltip="'حذف موارد انجام شده'" :loading="deleteAllSpinner" v-if="+completedTasks" @click="deleteCompletedTodos"></v-btn>
            <v-spacer></v-spacer>
            <v-progress-circular :model-value="progress" color="secondary"></v-progress-circular>
        </div>
        <v-divider class="mb-4"></v-divider>
        <v-list style="height: 250px;">
            <v-slide-y-transition group>
                <template v-for="(task, i) in tasks" :key="task.id">
                    <v-divider v-if="i !== 0"></v-divider>
                    <v-list-item v-ripple @mouseenter="task.deleteIcon = true" @mouseleave="task.deleteIcon = false">
                        <template #prepend>
                            <v-list-item-action>
                                <v-checkbox
                                    :color="task.done && 'grey' || 'primary'"
                                    hide-details
                                    v-model="task.done"
                                    @update:model-value="(done) => updateTask(task.id, done)"
                                    :disabled="disableDeleteIcon"
                                >
                                    <template #label>
                                        <label>
                                            <div :class="task.done && 'text-grey' || 'text-primary'" class="test-start me-4 ms-2 font-weight-medium text-small" v-text="task.name"></div>
                                        </label>
                                    </template>
                                </v-checkbox>
                            </v-list-item-action>
                        </template>
                        <template #append>
                            <v-slide-x-transition>
                                <div v-if="task.deleteIcon && !disableDeleteIcon">
                                    <v-icon @click="deleteTask(task.id)" class="cursor-pointer" color="error" icon="icon-trash"></v-icon>
                                </div>
                            </v-slide-x-transition>
                            <v-slide-x-transition>
                                <div v-if="task.done">
                                    <v-icon color="success" class="ms-2" icon="icon-verified"></v-icon>
                                </div>
                            </v-slide-x-transition>
                        </template>
                    </v-list-item>
                </template>
            </v-slide-y-transition>
        </v-list>
    </div>
</template>
<script setup>
const disableDeleteIcon = ref(true);
const tasks = ref(false);
const newTask = ref(null);
const todoSpinner = ref(false);
const deleteAllSpinner = ref(false);
const api = useApi();
const toast = useToastStore();

const completedTasks = computed(() => {
    return tasks.value !== false ? parseInt(tasks.value.filter((task) => task.done).length) : 0;
});
const progress = computed(() => {
    return tasks.value !== false && tasks.value.length ? (completedTasks.value / parseInt(tasks.value.length)) * 100 : 0;
});
const remainingTasks = computed(() => {
    return tasks.value !== false ? parseInt(tasks.value.length) - completedTasks.value : 0;
});

async function createNewTask() {
    todoSpinner.value = true;
    await api.todoStore({ name: newTask.value }).then(async (res) => {
        if (res && res.status == "CREATED") {
            await getTasks();
            todoSpinner.value = false;
        }
    });
    newTask.value = null;
}
function deleteTask(id) {
    disableDeleteIcon.value = true;
    api.todoDelete(id).then((res) => {
        if (res && res.status == "DELETED")
            getTasks();
    });
}
function updateTask(id, done) {
    api.todoUpdate(id, { done: done }).then((res) => {
        if (res && res.status == "UPDATED")
            getTasks();
    });
}
function deleteCompletedTodos() {
    deleteAllSpinner.value = true;
    api.deleteDoneTodos().then(async res => {
        if(res && res.status == "DELETED"){
            await getTasks();
            deleteAllSpinner.value = false;
            toast.success(res.message);
        }
    })
}
async function getTasks() {
    api.todoList().then((res) => {
        if (res && res.status == "OK")
            tasks.value = res.data.map((item) => {
                return { ...item, deleteIcon: false };
            });

    }).finally(()=>{disableDeleteIcon.value = false});
}
getTasks();
</script>
